import React, { ComponentProps, forwardRef } from 'react';

import { LegacySecondaryButton as SecondaryButton } from 'components/Button/LegacySecondaryButton';
import { Link as RouterLink } from 'components/RouterLink';

export const SecondaryButtonRouterLink = forwardRef<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  ComponentProps<typeof SecondaryButton>
>((props, ref) => (
  <SecondaryButton
    component={RouterLink}
    type={null}
    ref={ref}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
));
